import LANGUAGES_DICT from '~/server_shared/generated-types/LANGUAGES_DICT';
import type { SmsCommunicationBase } from '~/server_shared/swagger/data-contracts';

import type { CommunicationAttachment } from './types';

// URL path segments of the channels whose cards render `CommunicationAttachmentTable`. These are the
// route segments registered under `/api/v1/communications/` (server/api/communications.py), not the
// `Communication.channel` discriminators.
export const COMMUNICATION_ATTACHMENT_CHANNELS = ['emails', 'sms', 'video'] as const;

export type CommunicationAttachmentChannel = (typeof COMMUNICATION_ATTACHMENT_CHANNELS)[number];

export const getAttachmentFileUrl = (
  attachment: CommunicationAttachment,
  channel: CommunicationAttachmentChannel
): string => {
  return !attachment.document
    ? `/api/v1/communications/${channel}/${attachment.communication_id}/attachments/${attachment.id}/stored_file`
    : `/api/v1/claims/${attachment.document.claim_id}/documents/${attachment.document.id}`;
};

export const getLanguageName = (languageAndLocalCode?: string): string | null => {
  if (!languageAndLocalCode) return null;

  const languageCode = languageAndLocalCode.split('-')[0];
  return LANGUAGES_DICT[languageCode as keyof typeof LANGUAGES_DICT];
};

// Communications of other channels do not carry the field, so an absent count reads as none.
export const getNotRetrievedMediaCount = (
  communication: { channel: string } & Pick<SmsCommunicationBase, 'not_retrieved_media_count'>
): number => communication.not_retrieved_media_count ?? 0;

export const notRetrievedMediaLabel = (count: number): string =>
  count === 1 ? 'Attachment could not be retrieved' : `${count} attachments could not be retrieved`;
